<div class="pill">
  <i class="material-icons chevron-icon pill__icon">error_outline</i>
  <span class="pill__text">Midas</span>
</div>
